import logo from './logo.svg';
//import './App.css';
import ChatbotLayout from './chatbot';
import LoginPage from './loginpage';
import { useState } from 'react';
import ConfigForm from './configform';
import AdminDashboard from './adminpanel';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
function App() {


  const [applang, setAppLang] = useState(
        // Cerca la lingua salvata in localStorage, altrimenti default 'it'
        localStorage.getItem('appLanguage') || 'it'
    ); 
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Inizialmente non autenticato
  const [Email, setEmail] = useState(false); // Inizialmente non autenticato
  const [isAdmin, setAdmin] = useState(''); // Inizialmente non autenticato
  
   // const navigate = useNavigate()
    const handleLoginSuccess = (email, profilo) => {
        setIsLoggedIn(true);
        setEmail(email)
        setAdmin(profilo === "admin")
        console.log("handelLoginSuccess")
 
        
    };

    const handleLogout = () => {
        if (window.confirm("Vuoi davvero uscire?")) {
            setIsLoggedIn(false);
            localStorage.setItem("token", "");
        }
    };
    
    const [showSettings, setShowSettings] = useState(false);

    const handleSettings = () => {
        if (isLoggedIn) {
            // Cambia lo stato per mostrare i settings
            setShowSettings(true);
        }
    }
     const handleReturn = () => {
        if (isLoggedIn) {
            // Cambia lo stato per mostrare i settings
            if (showSettings)
                setShowSettings(false);
            else
                handleLogout()
        }
    }
      
     
    if (isLoggedIn) {
        if (isAdmin || showSettings) 
        {
            console.log (isAdmin);
            return  <AdminDashboard handleLogout={handleReturn}/>;
        }
        else
            return <ChatbotLayout Email={Email} handleLogout={handleLogout} handleSettings={handleSettings} />;
    } else {
        return <LoginPage handleLoginSuccess={handleLoginSuccess} />;
    }
/*
     return (<Router>
      <Routes>
        <Route path="/login" element={<LoginPage handleLoginSuccess={handleLoginSuccess} />} />
        <Route
          path="/"
          element={ <Navigate to="/login" />}
        />
        <Route
          path="/admin"
          element={isLoggedIn &&(isAdmin || showSettings) ? <AdminDashboard handleLogout={handleReturn} /> : <Navigate to="/chat"/>}
        />
        <Route
          path="/chat"
          element={isLoggedIn && !isAdmin && !showSettings ? <ChatbotLayout Email={Email} handleLogout={handleLogout} handleSettings={handleSettings} /> : <Navigate to="/chat"/>}
        />
        <Route
          path="/createnewchat"
          element={<ChatConfigForm />} 
        />
          
        
      </Routes>
    </Router> );
*/
 
}

export default App;
